import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { type Editor, EditorContent, useEditorState } from '@tiptap/react';
import { cn } from '@/utils/tailwind.util';
import { WithUnderline } from '../WithUnderline';
import { Placeholder } from './Placeholder';
interface TextEditorInputProps extends ComponentPropsWithoutRef<typeof EditorContent> {
  editor: Editor | null;
  className?: string;
  placeholder?: string;
  placeholderClassName?: string;
  editorClassName?: string;
}
export const TextEditorInput = forwardRef<HTMLDivElement, TextEditorInputProps>(({
  editor,
  className,
  onFocus,
  placeholder,
  placeholderClassName,
  editorClassName,
  ...rest
}, ref) => {
  // useEditor 는 트랜잭션마다 다시 그리지 않으므로, 외부 값 동기화(setContent)로 비어 있음이
  // 바뀌어도 반영되도록 에디터 상태를 구독한다.
  const isEmpty = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isEmpty ?? false
  });
  return <WithUnderline ref={ref} tabIndex={0} onFocus={e => {
    e.stopPropagation();
    editor?.commands.focus();
  }} className={cn('w-full cursor-text', className)}>
        {placeholder && isEmpty && <Placeholder placeholder={placeholder} className={placeholderClassName} />}
        <EditorContent {...rest} tabIndex={-1} editor={editor} className={cn('w-full text-heading-md-bold', editorClassName)} />
      </WithUnderline>;
});